import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'base64Image',
  })
  
  export class Base64ImagePipe implements PipeTransform {

    constructor(public _DomSanitizer: DomSanitizer) { }

    transform(value: string, extension: string) {
        if (value != undefined) {
           var safeValue = this._DomSanitizer.bypassSecurityTrustResourceUrl(value);
           return `data:image/${extension};base64,${safeValue}`;
        }else{
           return '';
        }   
    }
  }


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/pipes/image.pipe.ts